"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GoogleplusSquare;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function GoogleplusSquare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "GooglePlus"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "googleplus-square"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M39.286,67.857a17.857,17.857,0,0,1,0-35.714A17.06,17.06,0,0,1,51.25,36.821l-4.839,4.661a10.019,10.019,0,0,0-7.107-2.75,11.288,11.288,0,0,0,0,22.572c7.071,0,9.714-5.09,10.142-7.7H39.286V47.464H56.143a14.557,14.557,0,0,1,.286,2.965c0,10.2-6.84,17.428-17.143,17.428Z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "78.571 53.25 73.393 53.25 73.393 58.429 68.179 58.429 68.179 53.25 63 53.25 63 48.036 68.179 48.036 68.179 42.857 73.393 42.857 73.393 48.036 78.571 48.036 78.571 53.25"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M81.429,92.5H18.571A11.084,11.084,0,0,1,7.5,81.429V18.571A11.084,11.084,0,0,1,18.571,7.5H81.429A11.084,11.084,0,0,1,92.5,18.571V81.429A11.084,11.084,0,0,1,81.429,92.5Zm-62.858-80A6.079,6.079,0,0,0,12.5,18.571V81.429A6.079,6.079,0,0,0,18.571,87.5H81.429A6.079,6.079,0,0,0,87.5,81.429V18.571A6.079,6.079,0,0,0,81.429,12.5Z"
  })))));
}